import type { ReactNode } from 'react';

type Tone = 'gray' | 'green' | 'amber' | 'red' | 'blue' | 'brand';

const toneClasses: Record<Tone, string> = {
  gray: 'bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300',
  green: 'bg-green-100 text-green-700 dark:bg-green-950 dark:text-green-300',
  amber: 'bg-amber-100 text-amber-700 dark:bg-amber-950 dark:text-amber-400',
  red: 'bg-red-100 text-red-700 dark:bg-red-950 dark:text-red-300',
  blue: 'bg-blue-100 text-blue-700 dark:bg-blue-950 dark:text-blue-300',
  brand: 'bg-brand-50 text-brand-700 dark:bg-brand-950 dark:text-brand-300',
};

const dotClasses: Record<Tone, string> = {
  gray: 'bg-gray-400',
  green: 'bg-green-500',
  amber: 'bg-amber-500',
  red: 'bg-red-500',
  blue: 'bg-blue-500',
  brand: 'bg-brand-500',
};

interface BadgeProps {
  tone?: Tone;
  children: ReactNode;
  /** Renders as a colored dot + plain text (no fill) — matches the Priority column style, e.g. "● High". */
  dot?: boolean;
}

export function Badge({ tone = 'gray', dot = false, children }: BadgeProps) {
  if (dot) {
    return (
      <span className="inline-flex items-center gap-1.5 text-xs font-medium text-gray-700 dark:text-gray-300">
        <span className={`h-1.5 w-1.5 shrink-0 rounded-full ${dotClasses[tone]}`} />
        {children}
      </span>
    );
  }

  return (
    <span className={`inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-medium ${toneClasses[tone]}`}>
      {children}
    </span>
  );
}
